import { Box } from '@mui/material'
import * as React from 'react'
import { lastEditedDate } from '../utility/TreeHelpers'
import { useGetTreeById } from '../../reducers/trees_hooks'

export function TreeEditInfo(ids: { treeId: string; versionId: string }) {
  const { tree } = useGetTreeById(ids)
  if (!tree) return null
  return (
    <Box width={200} padding="10px">
      <DateComponent title={'Created'} date={tree.created_at} />
      <DateComponent title={'Last Edited'} date={lastEditedDate(tree)} />
    </Box>
  )
}

export function DateComponent({
  title,
  date,
}: {
  title: string
  date: string | undefined
}) {
  if (!date) return null
  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between">
      <Box>{`${title}:`}</Box>
      <Box>{date.split('T')[0]}</Box>
    </Box>
  )
}
